<template>
	<div style="background-color: #FFFFFF; height: 814px;">
		<!-- 顶部标题和按钮 -->
		<div style="padding: 20px 20px; display: flex; align-items: flex-end;">
			<div style="flex: 1">
				<span style="font-weight: 600; font-size: 14px; color: #0F1A3A;">
					{{title}}
				</span>
			</div>
			<!-- 查看态：仅显示"编辑"按钮 -->
			<div v-show="localActiveDiv === 1">
				<el-button type="primary" size="mini" style="font-size: 12px;" @click="switchToEdit">
					<span style="padding: 10px 10px;">{{$t('巡检.编辑')}}</span>
				</el-button>
			</div>
			<!-- 编辑态：显示操作按钮组 -->
			<div v-show="localActiveDiv === 2">
				<el-button type="primary" plain size="small" @click="restoreDefault">{{$t('巡检.恢复默认配置')}}</el-button>
				<el-button type="primary" plain size="small" @click="switchToView">{{$t('public.cancel')}}</el-button>
				<el-button type="primary" size="small" @click="save">{{$t('public.save')}}</el-button>
			</div>
		</div>

		<!-- 巡检内容标签 -->
		<div
			style="height: 36px; background: #F4F8FF; font-weight: 400; font-size: 14px; color: #0F1A3A; padding: 10px 20px;">
			{{$t('巡检.巡检内容')}}
		</div>

		<!-- 树形结构 -->
		<div style="padding: 20px 20px;margin-bottom: 100px; height: 480px; overflow-y: auto; ">
			<el-tree ref="tree" :data="localTreeData" show-checkbox node-key="id" default-expand-all
				:expand-on-click-node="false" :default-checked-keys="defaultCheckedKeys"
				:disabled="localActiveDiv === 1" :key="localActiveDiv">
				<!-- 关键修改：添加节点选中状态判断，绑定动态样式 -->
				<span class="custom-tree-node" slot-scope="{ node, data }">
					<span 
						:class="[
							'disabled-node',
							{ 
								'checked-node': localActiveDiv === 1 && node.checked,
								'unchecked-node': localActiveDiv === 1 && !node.checked,
								'level-1-node': node.level === 1 
							}
						]">
						{{ node.label }}
					</span>
					<!-- 操作按钮：仅编辑态可见 -->
					<span v-show="localActiveDiv === 2">
						<el-button type="text" size="mini" @click="() => append(data)"
							v-show="node.level === 1">{{$t('巡检.增加巡检项')}}</el-button>
						<el-button type="text" size="mini"
							@click="() => modify(node, data)">{{$t('public.edit')}}</el-button>
						<el-button type="text" size="mini"
							@click="() => remove(node, data)">{{$t('public.del')}}</el-button>

						<!-- 一级节点上下移按钮 -->
						<el-button v-show="node.level === 1" type="text" icon="el-icon-upload2" size="mini"
							@click="() => moveUp(node, data)"></el-button>
						<el-button v-show="node.level === 1" type="text" icon="el-icon-download" size="mini"
							@click="() => moveDown(node, data)"></el-button>
					</span>
				</span>
			</el-tree>

			<!-- 修改弹窗 -->
			<el-dialog class="modifycontent" :title="$t('巡检.修改巡检内容')" :visible.sync="dialogVisible" width="440px"
				:close-on-click-modal="false">
				<el-form :model="formData" label-width="80px">
					<el-divider></el-divider>
					<el-form-item :label="$t('巡检.巡检内容')">
						<el-input v-model="formData.label" type="textarea" rows="10"
							:placeholder="$t('巡检.请输入巡检内容')"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">{{$t('public.cancel')}}</el-button>
					<el-button type="primary" @click="handleModifySubmit">{{$t('feedback.提交')}}</el-button>
				</div>
			</el-dialog>

			<!-- 新增弹窗 -->
			<el-dialog :title="$t('巡检.增加巡检项')" :visible.sync="addDialogVisible" width="440px"
				:close-on-click-modal="false">
				<el-divider></el-divider>
				<el-form :model="addFormData" label-width="80px">
					<el-form-item :label="$t('巡检.巡检项')">
						<el-input v-model="addFormData.label" type="textarea" rows="10"
							:placeholder="$t('巡检.请输入巡检项内容')"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="addDialogVisible = false">{{$t('public.cancel')}}</el-button>
					<el-button type="primary" @click="handleAddSubmit">{{$t('feedback.提交')}}</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	let id = 10;
	import {
		mapState
	} from 'vuex';
	export default {
		props: {
			title: {
				type: String,
				required: true
			},
			treeData: {
				type: Array,
				required: true
			},
			defaultCheckedKeys: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				localActiveDiv: 1,
				localTreeData: [], // 本地树数据副本
				initialTreeData: [], // 初始树数据备份
				initialCheckedKeys: [], // 初始选中状态备份
				dialogVisible: false,
				formData: {
					id: null,
					label: ""
				},
				addDialogVisible: false,
				addFormData: {
					label: ""
				},
				addParent: null,
				isFirstLoad: true, // 标记是否是首次加载
				currentCheckedKeys: [],
			};
		},
		mounted() {
			this.updateMaxId();
			this.disableAllNodes();
			// 初始化时确保一级节点sortOrder连续（避免初始数据异常）
			this.normalizeSortOrder(this.localTreeData);
		},
		computed: {
			size() {
				return this.$store.getters.size
			},
			...mapState({
				operator: state => state.user.operator
			})
		},
		watch: {
			treeData: {
			    immediate: true,
			    handler(newVal) {
			      if (this.isFirstLoad || this.localActiveDiv === 1) {
			        // 初始化时，initialTreeData设为接口查询的原始数据
			        this.localTreeData = JSON.parse(JSON.stringify(newVal));
			        this.initialTreeData = JSON.parse(JSON.stringify(newVal));
			        this.initialCheckedKeys = [...this.defaultCheckedKeys];
			        this.disableAllNodes();
			        this.normalizeSortOrder(this.localTreeData);
			        this.isFirstLoad = false;
			      }
			    }
			  }
		},
		methods: {
			getVehicleEnergyType() {
				return this.title === this.$t('巡检.纯电车车辆检查表') ? "纯电车" : "非纯电车";
			},
			resetEditState() {
				this.localActiveDiv = 1;
			},

			// 1. 新增：标准化同一层级节点的sortOrder（确保连续1、2、3...）
			normalizeSortOrder(nodes) {
			  if (!nodes || nodes.length === 0) return;
			  
			  // 移除：无需再排序（手动交换后顺序已正确）
			  // nodes.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
			  
			  // 仅重新赋值连续的 sortOrder
			  nodes.forEach((node, index) => {
			    this.$set(node, 'sortOrder', index + 1);
			    if (node.children && node.children.length) {
			      this.normalizeSortOrder(node.children);
			    }
			  });
			  
			  if (nodes === this.localTreeData) {
			    this.localTreeData = [...this.localTreeData];
			  }
			},

			// 启用所有节点（编辑态用）
			enableAllNodes() {
				const enableNodes = (nodes) => {
					nodes.forEach(node => {
						this.$set(node, 'disabled', false);
						if (node.children && node.children.length) enableNodes(node.children);
					});
				};
				enableNodes(this.localTreeData);
				this.localTreeData = [...this.localTreeData];
			},

			// 禁用所有节点（查看态用）
			disableAllNodes() {
				const disableNodes = (nodes) => {
					if (!nodes || nodes.length === 0) return;
					nodes.forEach(node => {
						this.$set(node, 'disabled', true);
						if (node.children && node.children.length) disableNodes(node.children);
					});
				};
				disableNodes(this.localTreeData);
				this.localTreeData = [...this.localTreeData];
			},

			// 切换到编辑态
			switchToEdit() {
				 this.localActiveDiv = 2; // 切换到编辑态
				  this.enableAllNodes(); // 先启用所有节点（确保组件可操作）
				
				  // 关键：等待DOM更新后，设置选中状态为上次保存的initialCheckedKeys
				  this.$nextTick(() => {
				    // 直接使用上次保存的选中状态（initialCheckedKeys）
				    this.$refs.tree.setCheckedKeys(this.initialCheckedKeys);
				  });
				
				  this.$message.info(this.$t('巡检.已进入编辑模式'));
			},

			// 切换到查看态
			switchToView() {
			  this.localActiveDiv = 1;
			  this.dialogVisible = false;
			  this.addDialogVisible = false;
			
			  // 1. 先恢复树数据和选中状态（此时树仍处于可操作状态）
			  this.localTreeData = JSON.parse(JSON.stringify(this.initialTreeData));
			  
			  // 2. 关键：在DOM更新后设置选中状态，确保树组件能正确接收
			  this.$nextTick(() => {
			    // 设置最新的选中状态（保存后是更新后的initialCheckedKeys，未保存是初始值）
			    this.$refs.tree.setCheckedKeys(this.initialCheckedKeys);
			    
			    // 3. 最后禁用节点（确保设置选中状态时组件未被禁用）
			    this.disableAllNodes();
			    this.$refs.tree.disabled = true;
			  });
			
			  // 清空弹窗临时数据
			  this.formData = { id: null, label: "" };
			  this.addFormData = { label: "" };
			  this.addParent = null;
			
			  this.$message.info(this.$t('巡检.已退出编辑模式'));
			},

			// 恢复默认：仅恢复到上次保存的前端数据
			restoreDefault() {
			  this.localTreeData = JSON.parse(JSON.stringify(this.initialTreeData));
			  this.$refs.tree.setCheckedKeys(this.initialCheckedKeys);
			  this.enableAllNodes();
			  this.normalizeSortOrder(this.localTreeData);
			  this.$message.success(this.$t('巡检.已恢复默认配置'));
			},

			// 保存时调用接口提交全量数据
			save() {
			  const checkedKeys = this.$refs.tree.getCheckedKeys();
			  // 1. 扁平化树数据
			  let flatData = this.flattenTree(this.localTreeData);
			  // 2. 按sortOrder排序
			  flatData = flatData.sort((a, b) => a.sortOrder - b.sortOrder);
			  // 3. 生成提交数据（包含VehicleEnergyType）
			  const submitData = flatData.map(node => ({
			    CompanyID: this.operator.CompanyId,
			    IsEnabled: checkedKeys.includes(node.id) ? 1 : 0,
			    TempID: node.id,
			    ParentTempID: node.PItemID,
			    SortOrder: node.sortOrder,
			    Title: node.label,
			    VehicleEnergyType: this.getVehicleEnergyType() // 按当前tab传递类型
			  }));
			
			  // 仅此处调用接口
			  this.$api.saveInspectionDefault({
			    data: submitData,
			    VehicleEnergyType: this.getVehicleEnergyType() // 接口参数添加车辆类型
			  }).then((res) => {
			     if (res.code === 200) {
			          this.$message.success(this.$t('public.hasSaved'));
			          // 关键：同步更新初始选中状态为当前保存的选中值
			          this.initialTreeData = JSON.parse(JSON.stringify(this.localTreeData));
			          this.initialCheckedKeys = [...checkedKeys]; // 确保这里正确赋值
			          this.switchToView(); // 调用切换方法，此时initialCheckedKeys已更新
			        } else {
			          this.$message.error(res.msg || this.$t('public.SaveFail'));
			        }
			  }).catch(() => {
			    this.$message.error(this.$t('public.SaveFail'));
			  });
			},

			// 树形结构扁平化（用于提交数据）
			flattenTree(nodes, parentId = 0) {
				let result = [];
				nodes.forEach(node => {
					result.push({
						id: node.id,
						label: node.label,
						sortOrder: node.sortOrder, // 携带最新排序号
						PItemID: parentId,
						children: []
					});
					// 递归处理子节点
					if (node.children && node.children.length) {
						result = result.concat(this.flattenTree(node.children, node.id));
					}
				});
				return result;
			},

			// 更新最大节点ID（避免新增节点ID重复）
			updateMaxId() {
				const getMaxId = (nodes) => {
					let max = 0;
					nodes.forEach(node => {
						max = Math.max(max, node.id);
						if (node.children && node.children.length) max = Math.max(max, getMaxId(node
						.children));
					});
					return max;
				};
				const maxId = getMaxId(this.treeData);
				id = maxId > id ? maxId : id;
			},

			// 打开新增弹窗
			append(data) {
				this.addParent = data;
				this.addFormData.label = "";
				this.addDialogVisible = true;
			},

			// 新增巡检项：接口成功后更新本地
			async handleAddSubmit() {
			  const content = this.addFormData.label.trim();
			  if (!content) {
			    this.$message.warning(this.$t('巡检.请输入巡检项内容'));
			    return;
			  }
			
			  // 仅前端新增节点，不调用接口
			  const parentChildren = this.addParent.children || [];
			  const newChild = {
			    id: ++id, // 前端临时ID，保存时提交给后端
			    label: content,
			    children: [],
			    sortOrder: parentChildren.length + 1,
			    PItemID: this.addParent.id,
			    VehicleEnergyType: this.getVehicleEnergyType()
			  };
			
			  if (!this.addParent.children) this.$set(this.addParent, "children", []);
			  this.addParent.children.push(newChild);
			  this.normalizeSortOrder(this.addParent.children); // 同步排序号
			  this.addDialogVisible = false;
			  this.$message.success(this.$t('巡检.新增成功')); // 提示暂存状态
			},

			// 删除巡检项：接口成功后更新本地
			remove(node, data) {
			  const parent = node.parent;
			  const children = parent.data.children || parent.data;
			  const index = children.findIndex(d => d.id === data.id);
			  if (index === -1) {
			    this.$message.error(this.$t('巡检.节点不存在'));
			    return;
			  }
			
			  // 仅前端删除节点，不调用接口
			  children.splice(index, 1);
			  this.normalizeSortOrder(children); // 同步排序号
			  this.$message.success(this.$t('巡检.删除成功')); // 提示暂存状态
			},
			// 打开修改弹窗
			modify(node, data) {
				this.formData.id = data.id;
				this.formData.label = data.label;
				this.dialogVisible = true;
			},
			// 修改巡检项：接口成功后更新本地
			handleModifySubmit() {
			  const findNode = (tree, id) => {
			    for (const node of tree) {
			      if (node.id === id) return node;
			      if (node.children && node.children.length) {
			        const res = findNode(node.children, id);
			        if (res) return res;
			      }
			    }
			    return null;
			  };
			  const targetNode = findNode(this.localTreeData, this.formData.id);
			  if (!targetNode) {
			    this.$message.error(this.$t('巡检.节点不存在或已删除'));
			    this.dialogVisible = false;
			    return;
			  }
			  // 仅前端修改节点，不调用接口
			  targetNode.label = this.formData.label;
			  this.dialogVisible = false;
			  this.$message.success(this.$t('巡检.修改成功')); // 提示暂存状态
			},

			// 一级节点上移：修复数组获取和视图更新
			moveUp(node, data) {
			  // 一级节点的父节点是根节点，直接操作 localTreeData（一级节点数组）
			  const children = this.localTreeData;
			  const index = children.findIndex(d => d.id === data.id);
			  
			  if (index <= 0) {
			    this.$message.warning(this.$t('巡检.不能上移'));
			    return;
			  }
			
			  // 交换节点（使用数组解构，确保响应式更新）
			  [children[index], children[index - 1]] = [children[index - 1], children[index]];
			  
			  // 关键：重新赋值数组触发响应式
			  this.localTreeData = [...children];
			  
			  // 标准化排序号（直接传递一级节点数组）
			  this.normalizeSortOrder(this.localTreeData);
			  
			  this.$message.success(this.$t('巡检.上移成功'));
			},
			
			// 一级节点下移：修复数组获取和视图更新
			moveDown(node, data) {
			  // 一级节点的父节点是根节点，直接操作 localTreeData（一级节点数组）
			  const children = this.localTreeData;
			  const index = children.findIndex(d => d.id === data.id);
			  
			  if (index >= children.length - 1) {
			    this.$message.warning(this.$t('巡检.不能下移'));
			    return;
			  }
			
			  // 交换节点（使用数组解构，确保响应式更新）
			  [children[index], children[index + 1]] = [children[index + 1], children[index]];
			  this.localTreeData = [...children];
			  
			  // 标准化排序号（直接传递一级节点数组）
			  this.normalizeSortOrder(this.localTreeData);
			  
			  this.$message.success(this.$t('巡检.下移成功'));
			},
		}
	}
</script>

<style lang="scss" scoped>
	// 关键修改：查看态样式调整
	::v-deep {
		// 查看态（禁用状态）的勾选框样式
		.el-tree.is-disabled {
			.el-checkbox__input.is-checked .el-checkbox__inner {
				background-color: #A2B1CB !important; // 选中勾选框背景色
				border-color: #A2B1CB !important;
			}
			.el-checkbox__inner::after {
				background-color: #FFFFFF !important; // 勾选标记颜色
			}
		}

		// 查看态选中节点样式
		.checked-node {
			font-size: 12px !important;
			color: #0F1A3A !important;
			cursor: default;
		}

		// 查看态未选中节点样式
		.unchecked-node {
			font-size: 12px !important;
			color: rgba(15, 26, 58, 0.5) !important; // #0F1A3A 50%透明度
			cursor: default;
		}
		.level-1-node {
					font-weight: 600 !important;
				}
	}

	.el-tree {
		&.is-disabled {
			opacity: 1; // 取消禁用状态的透明度降低，保持清晰
		}

		.el-tree-node.is-disabled {
			.el-tree-node__label {
				color: inherit !important; // 继承自定义颜色，覆盖默认禁用色
				cursor: default;
			}

			.el-checkbox__input {
				cursor: default;
			}

			.el-checkbox__input.is-disabled+.el-checkbox__label {
				color: inherit !important; // 继承自定义颜色
			}
		}
	}

	.custom-tree-node {
		display: flex;
		align-items: center;
		width: 100%;
		padding: 2px 0;
	}

	.disabled-node {
		// 基础样式，查看态会被checked-node/unchecked-node覆盖
		font-size: 12px;
		color: #0F1A3A;
	}
</style>